import { render, staticRenderFns } from "./stupage.vue?vue&type=template&id=5136c218&scoped=true"
import script from "./stupage.vue?vue&type=script&lang=js"
export * from "./stupage.vue?vue&type=script&lang=js"
import style0 from "./stupage.vue?vue&type=style&index=0&id=5136c218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5136c218",
  null
  
)

export default component.exports